import React, {useEffect, useRef, useState} from 'react';
import {Button, TextField} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {getPushNotificationOptions} from '../../Services/pushNotif';

export default function NotificationLookup({type, value, onChange}) {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(value);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [retry, setRetry] = useState(0);
  const [offset, setOffset] = useState(0);
  const generation = useRef(0);
  const label = item => type === 'article' ? (item.title || item.id || '') : (item.name ? `${item.name}${item.code ? ` - ${item.code}` : ''}` : item.id || '');

  useEffect(() => {
    let active = true;
    setSelected(value);
    if (value && !value.name && !value.title) {
      getPushNotificationOptions({type, id: value.id}).then(res => {
        if (active && res.data.items.length) setSelected(res.data.items[0]);
      }).catch(() => {});
    }
    return () => { active = false; };
  }, [type, value]);

  useEffect(() => {
    const request = ++generation.current;
    setLoading(true);
    setError(false);
    const timer = setTimeout(() => {
      getPushNotificationOptions({type, search, skip: offset, limit: 30}).then(res => {
        if (generation.current !== request) return;
        setItems(previous => offset ? [...previous, ...res.data.items.filter(item => !previous.some(existing => existing.id === item.id))] : res.data.items);
        setHasMore(res.data.hasMore);
        setLoading(false);
      }).catch(() => {
        if (generation.current !== request) return;
        setError(true);
        setLoading(false);
      });
    }, search ? 300 : 0);
    return () => { clearTimeout(timer); generation.current++; };
  }, [type, search, offset, retry]);

  const options = selected && !items.some(item => item.id === selected.id) ? [selected, ...items] : items;
  return <>
    <Autocomplete
      options={options}
      value={selected || null}
      getOptionLabel={label}
      getOptionSelected={(option, current) => option.id === current.id}
      filterOptions={options => options}
      loading={loading}
      onInputChange={(_, input, reason) => {
        if (reason !== 'input' && reason !== 'clear') return;
        if (input === search && offset === 0) return;
        generation.current++;
        setItems([]);
        setHasMore(false);
        setSearch(input);
        setOffset(0);
      }}
      onChange={(_, next) => { setSelected(next); onChange(next); }}
      renderInput={params => <TextField {...params} name={`${type}Search`} label={`Select ${type}`} margin="normal" fullWidth error={error} FormHelperTextProps={{'aria-live': 'polite'}} helperText={error ? 'Unable to load options. Retry below.' : loading ? 'Loading…' : ''} />}
    />
    {error && <Button onClick={() => setRetry(previous => previous + 1)}>Retry options</Button>}
    {hasMore && !error && <Button disabled={loading} onClick={() => setOffset(previous => previous + 30)}>Load more options</Button>}
  </>;
}
